import React, { useContext, useEffect, useState } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Downtime.css";
import InputBar from "../minda/InputBar/InputBar";
import { useSelector } from "react-redux";
import { AuthInfo, ConfigContext } from "../../../../App";
import { isIsoDate, jsonToURL, locale, msToHHMMSS, typeConfigs, isoToReadable } from "../../../../utils";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DowntimeEntry } from "./DowntimeEntry.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { ActionsEntry } from "./ActionsEntry";
import { StrokesGraph } from "../minda/Strokes/Graph";
import { useSearchParams } from "react-router-dom";

export const DownTimeTable = (props) => {
  toast.configure();
  const { companyId, mmHost } = useContext(ConfigContext);
  const { userInfo, userId } = useContext(AuthInfo);
  const [loading, setloading] = useState(false);
  const [downtimeData, setDowntimeData] = useState();
  const [fetchStatus, setFetchStatus] = useState(true);
  const [strokesGraphFlag, setStrokesGraphFlag] = useState(true);

  const [searchParams] = useSearchParams();

  let goback = searchParams.get("goback");

  let plantId = useSelector((state) => state.saveSelectedPlant);
  if (plantId.downtime) {
    plantId = plantId.downtime.selectedOption.value;
  } else {
    plantId = "";
  }

  let machineType = useSelector((state) => state.saveSelectedMachineType);
  if (machineType.downtime) {
    machineType = machineType.downtime.selectedOption.value;
  } else {
    machineType = "";
  }

  let lineId = useSelector((state) => state.saveSelectedLine);
  if (lineId.downtime) {
    lineId = lineId.downtime.selectedOption.value;
  } else {
    lineId = "";
  }

  let machineId = useSelector((state) => state.saveSelectedMachine);
  let machineName = "";

  if (machineId.downtime) {
    machineName = machineId.downtime.selectedOption.label;
    machineId = machineId.downtime.selectedOption.value;
  } else {
    machineId = "";
  }

  let timings = useSelector((state) => state.timings);

  timings = timings.downtime;

  let startTime = 1;
  let endTime = 1;
  if (timings) {
    startTime = timings.startTime.getISOStringOfTimezone();
    endTime = timings.endTime.getISOStringOfTimezone();
  }

  let downtimeAbove;
  let parameter;
  let maximum;
  let heading;

  if(machineType=="welding"){    
    parameter = typeConfigs.weld.availParam.key;
    maximum = typeConfigs.weld.availParam.max;
    downtimeAbove = typeConfigs.weld.downtimeAbove;
    heading = typeConfigs.weld.availParam.note;
    machineId = "hsqn"
  }else{
    parameter = typeConfigs.stamping.availParam.key;
    maximum = typeConfigs.stamping.availParam.max;
    downtimeAbove = typeConfigs.stamping.downtimeAbove;
    heading = typeConfigs.stamping.availParam.note;
  }

  let queryParams = {
    startTime,
    endTime,
    plantId,
    machineType,
    lineId,
    machineId,
    downtimeAbove,
    source:'downtimePage',
    parameter
  };

  const updateData = async () => {
    if (!isIsoDate(queryParams.startTime) || !isIsoDate(queryParams.endTime)) {
      throw "INVALID TIME FORMAT";
      return;
    }

    let downtimeURL = `${mmHost}/chartserver/downtime?${jsonToURL(
      queryParams
    )}`;

    if (
      plantId == "" ||
      lineId == "" ||
      machineId == "" ||
      !startTime ||
      !endTime
    ) {
      if (!startTime || !endTime) {
        // toast.error("Invalid Time Range", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        return;
      }

      // toast.info("Please Select All 5 Plant, Line, Machine, Shift and Shift Date", {
      //   position: toast.POSITION.TOP_LEFT,
      // });
      return;
    }

    setloading(true);
    axios
      .get(downtimeURL)
      .then(function (data) {
        setDowntimeData(data.data);
        setloading(false);

        // toast.info("Downtime Loaded", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        return;
      })
      .catch(() => {
        setloading(false);
        // toast.error("Downtime couldn't load", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        return;
      });
  };

  useEffect(() => {
    updateData();
    setStrokesGraphFlag(!strokesGraphFlag);
  }, [fetchStatus]);

  useEffect(() => {
    setTimeout(() => {
      setFetchStatus(!fetchStatus);
    }, 500);
  }, []);

  let tableRows;

  if (downtimeData) {
    if (downtimeData["downTimeArray"]) {
      tableRows = downtimeData["downTimeArray"].map((downtime) => {
        return (
          <DowntimeTableRow
            key={downtime.startTime}
            downtime={downtime}
            queryParams={queryParams}
            setFetchStatus={setFetchStatus}
            fetchStatus={fetchStatus}
          ></DowntimeTableRow>
        );
      });
    }
  }

  let connectionLossTime = '-';
  try {
    connectionLossTime = downtimeData["durationReq"] - downtimeData["up_plus_down_plus_other"];
  } catch (error) {
    console.error(error)
  }
  
  console.log(connectionLossTime)

  return (
    <>
      <div className="box box-default">
        <div className="box-header">
          <InputBar
            setData={setDowntimeData}
            setFetchStatus={setFetchStatus}
            fetchStatus={fetchStatus}
            loading={loading}
            InsIden={"downtime"}
            machineType={true}
            line={true}
            machine={true}
            shift={true}
            shiftDate={true}
            startTime={true}
            endTime={true}
            goback={{ show: goback == "true" ? true : false }}
          ></InputBar>
        </div>
        <div className="box-body">
          <h3 className="text-center">{machineName}</h3>
          {loading ? (
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <Table id="downtimeTable" striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Duration</th>
                  <th>Reason</th>
                  <th>Root Cause Analysis</th>
                  <th>Corrective Action Taken/Planned</th>
                  <th>Responsibility</th>
                  <th>Target Date</th>
                  <th>Remarks</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>{tableRows}</tbody>
            </Table>
          )}
        </div>
        <div className="text-center">
          {
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button btn btn-primary"
              table="downtimeTable"
              filename={`${machineName} ${startTime} + ${endTime}`}
              sheet="tablexls"
              buttonText="Download as Excel"
            />
          }
        </div>
        <br></br>
        <br></br>
        { timings ?
        (<StrokesGraph
          startTime={timings.startTime}
          endTime={timings.endTime}
          groupBy={"machine"}
          alldata={"1"}
          machineId={queryParams.machineId}
          lineId={queryParams.lineId}
          plantId={queryParams.plantId}
          strokesGraphFlag={strokesGraphFlag}
          setStrokesGraphFlag={setStrokesGraphFlag}
          name={parameter}
          parameter = {parameter}
          maximum = {maximum}
          heading = {heading}
        />) : (
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )};
        <br></br>
        <h4>Connection Loss Time {Math.floor(connectionLossTime)} mins</h4>
      </div>
    </>
  );
};

const DowntimeTableRow = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const closeModal2 = () => {
    setShowModal2(false);
  };

  const onEditIconClick = () => {
    setShowModal(true);
  };

  const onEditIconClick2 = () => {
    setShowModal2(true);
  };

  return (
    <>
      <tr>
        <td>{isoToReadable(props.downtime.startTime)}</td>
        <td>{isoToReadable(props.downtime.endTime)}</td>
        <td>{msToHHMMSS(props.downtime.duration * 60000)}</td>
        <td>
          {(() => {
            let reasonArray = props.downtime.reason;
            if (reasonArray.length > 0) {
              let reasonString = "";
              for (let j = 0; j < reasonArray.length; j++) {
                let reason = reasonArray[j];
                reasonString =
                  reasonString +
                  `${reason["reasonDescrp"]}  (${
                    reason["reasonCode"]
                  }) ${msToHHMMSS(
                    reason["splitInfo"]["subReasonDuration"]
                  )} -${(() => {
                    try {
                      return reason["loginInfo"]["profile"]["name"];
                    } catch {
                      return "";
                    }
                  })()},`;
              }
              return reasonString;
            }
          })()}{" "}
          <FontAwesomeIcon
            onClick={onEditIconClick}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>


        <td>
          {(() => {
            try{
              return props.downtime['actions'][0]['rootCauseAnalysis']['description'];
            }catch(e){
              return "-";
            }
          })()}
          <FontAwesomeIcon
            onClick={onEditIconClick2}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>
        <td>
        {(() => {
            try{
              return props.downtime['actions'][0]['correctivePlan']['description'];
            }catch(e){
              return "-";
            }
          })()}
          <FontAwesomeIcon
            onClick={onEditIconClick2}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>
        <td>
        {(() => {
            try{
              return props.downtime['actions'][0]['responsibility']['description'];
            }catch(e){
              return "-";
            }
          })()}
          <FontAwesomeIcon
            onClick={onEditIconClick2}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>
        <td>
        {(() => {
            try{
              return props.downtime['actions'][0]['targetDate']['description'];
            }catch(e){
              return "-";
            }
          })()}
          <FontAwesomeIcon
            onClick={onEditIconClick2}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>
        <td>
        {(() => {
            try{
              return props.downtime['actions'][0]['remarks']['description'];
            }catch(e){
              return "-";
            }
          })()}
          <FontAwesomeIcon
            onClick={onEditIconClick2}
            type="button"
            style={{ float: "right" }}
            icon={faEdit}
          />
        </td>
        <td className="pulse">
          <h6>{props.downtime.status}</h6>
        </td>



      </tr>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Downtime ({props.downtime.duration.toFixed(0)} minutes)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DowntimeEntry
            downtime={props.downtime}
            queryParams={props.queryParams}
            setFetchStatus={props.setFetchStatus}
            fetchStatus={props.fetchStatus}
            setShowModal={setShowModal}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModal2} onHide={closeModal2}>
        <Modal.Header closeButton>
          <Modal.Title>Actions Taken</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ActionsEntry
            downtime={props.downtime}
            queryParams={props.queryParams}
            setFetchStatus={props.setFetchStatus}
            fetchStatus={props.fetchStatus}
            setShowModal={setShowModal2}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

//sortability
//saving the action
//fixing the time stamps

//enhancements
//1. planned unplanned striplines
